"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ListItemText = _interopRequireDefault(require("@eig-builder/core-ui/ListItemText"));

var _MenuItem = _interopRequireDefault(require("@eig-builder/core-ui/MenuItem"));

var _taggingHelper = require("@eig-builder/core-utils/helpers/tagging-helper");

// Core
// Component
var RenderSuggestion = function RenderSuggestion(suggestionProps) {
  var suggestion = suggestionProps.suggestion,
      itemProps = suggestionProps.itemProps,
      index = suggestionProps.index,
      highlightedIndex = suggestionProps.highlightedIndex,
      dataElementSuffix = suggestionProps.dataElementSuffix,
      noItemFoundText = suggestionProps.noItemFoundText; // This is a fallback if no suggestions are found

  if (!suggestion) {
    return _react["default"].createElement(_MenuItem["default"], (0, _extends2["default"])({}, itemProps, {
      key: "no-item-found",
      component: "div",
      dataElementLocation: _taggingHelper.DataElementLocations.BODY,
      dataElementLabel: "control-autocomplete-suggestion-no-item-found-".concat(dataElementSuffix),
      dataElementId: "control-autocomplete-suggestion-no-item-found-".concat(dataElementSuffix),
      disabled: true
    }), _react["default"].createElement(_ListItemText["default"], {
      primary: noItemFoundText
    }));
  } // Otherwise continue to render the auto-complete suggestion.


  var isHighlighted = highlightedIndex === index; // Suggestion values

  var value = suggestion.value;
  var label = suggestion.label || suggestion.value;
  var secondaryLabel = suggestion.secondaryLabel; // Render the menu item

  return _react["default"].createElement(_MenuItem["default"], (0, _extends2["default"])({}, itemProps, {
    key: value,
    selected: isHighlighted,
    component: "div",
    dataElementLocation: _taggingHelper.DataElementLocations.BODY,
    dataElementLabel: "control-autocomplete-suggestion-".concat(value, "-").concat(dataElementSuffix),
    dataElementId: "control-autocomplete-suggestion-".concat(value, "-").concat(dataElementSuffix)
  }), _react["default"].createElement(_ListItemText["default"], {
    primary: label,
    secondary: secondaryLabel
  }));
};

RenderSuggestion.propTypes = {
  highlightedIndex: _propTypes["default"].oneOfType([_propTypes["default"].oneOf([null]), _propTypes["default"].number]),
  noItemFoundText: _propTypes["default"].string,
  index: _propTypes["default"].number,
  itemProps: _propTypes["default"].object,
  selectedItem: _propTypes["default"].string,
  suggestion: _propTypes["default"].shape({
    label: _propTypes["default"].string
  }),
  classes: _propTypes["default"].object
};
var _default = RenderSuggestion;
exports["default"] = _default;